import {
  CHART_CONFIGURATION_FIELDS,
  USER_DATAPOINT_FIELDS_FOR_COT,
  USER_TEST_FIELDS_TRUNCATED
} from "@/graphql/tpo/results/types";
import { gql } from "@apollo/client";

export const LAB_REPORTS_QUERY = gql`
  query LabReportsQuery($userTestId: ID!, $userId: ID!, $forPractitioner: Boolean) {
    userTest(userTestId: $userTestId, userId: $userId) {
      id
      generatedPdf {
        id
        name
        userTest {
          id
        }
        pdfFile
      }
      dataFiles(forPractitioner: $forPractitioner) {
        id
        name
        dataFileUrl
        testDataFile {
          id
          fileType {
            id
            name
            contentType
            extension
          }
        }
      }
    }
  }
`;

export const USER_DATAPOINT_QUERY = gql`
  query USER_DATAPOINT_QUERY($userDatapointId: ID!, $userId: ID!) {
    userDatapoint(userDatapointId: $userDatapointId, userId: $userId) {
      id
      uploaded
      dateExpired
      datapoint {
        id
        name
        category
        units
        description
        function
        reason
        chartType
        testProductSet {
          id
          paymentIsoCode
          organisation
          productFamily {
            id
            name
            slug
          }
        }
      }
      riskAllele
      value
      interpretation
      riskAllele
      chartConfiguration {
        ...ChartConfigurationFields
      }
      datapointState {
        id
        description
      }
    }
  }
  ${CHART_CONFIGURATION_FIELDS}
`;

export const RELATED_RESEARCH_QUERY = gql`
  query RelatedResearchQuery($userId: ID!, $userResultId: ID!) {
    userResult(userId: $userId, userResultId: $userResultId) {
      id
      research {
        id
        name
        url
      }
    }
  }
`;

export const USER_DATAPOINTS_QUERY = gql`
  query UserDatapointsQuery($datapointId: ID!, $cot: Boolean, $userId: ID!) {
    userDatapoints(datapointId: $datapointId, cot: $cot, userId: $userId) {
      ...UserDatapointFieldsForCot
    }
  }
  ${USER_DATAPOINT_FIELDS_FOR_COT}
`;

export const GENES_TEST_BIOMARKERS_CONNECTION_QUERY = gql`
  query GENES_TEST_BIOMARKERS_CONNECTIONS_QUERY(
    $userId: ID!
    $userResultId: ID
    $userTestId: ID
    $first: Int!
    $after: String
    $search: String
    $orderBy: String
    $includeModifiers: Boolean
    $testMode: Boolean
  ) {
    userDatapointConnections(
      userId: $userId
      userResultId: $userResultId
      userTestId: $userTestId
      after: $after
      first: $first
      search: $search
      orderBy: $orderBy
      includeModifiers: $includeModifiers
      testMode: $testMode
    ) {
      edges {
        cursor
        node {
          id
          value
          riskAllele
          datapoint {
            id
            name
            chartType
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const USER_TESTS_AND_ORDERS_QUERY = gql`
  query UserTestsAndOrdersQuery($allTests: Boolean, $includeUnapproved: Boolean, $userId: ID!) {
    userTests(allTests: $allTests, includeUnapproved: $includeUnapproved, userId: $userId) {
      id
      name
      createdDateFormatted
      reviewStatus
      displayOrderId
    }
    ordersInProgress(userId: $userId) {
      id
      resultsReceivedByProvider
      sampleReceivedByProvider
      sampleReceivedByLab
      hasUserReport(mode: REPORT_AVAILABLE)
      nameInBasket
      registered
      testSentToUser
      product {
        id
        name
        paymentIsoCode
        organisation
        listingVisibility
      }
      userTestIds
      displayOrderId
    }
  }
`;

export const RESEARCH_RELATED_TO_USER_DATAPOINT_QUERY = gql`
  query RelatedResearchQuery($userDatapointId: ID!, $userId: ID!) {
    userDatapoint(userDatapointId: $userDatapointId, userId: $userId) {
      id
      datapointState {
        id
        research {
          id
          name
          url
        }
      }
    }
  }
`;

export const USER_TEST_QUERY = gql`
  query UserTestQuery($userTestId: ID!, $userId: ID!) {
    userTest(userTestId: $userTestId, userId: $userId) {
      ...UserTestFieldsTruncated
      isGenesTest
      reviewStatus
      displayOrderId
    }
  }
  ${USER_TEST_FIELDS_TRUNCATED}
`;
